import './index.less'
import '@utils/scrollend.js'

export default class MembershipAnchor {
  constructor() {
    this.anchorSection = document.querySelector('[data-sticky-anchor-section]')
    this.anchorWrap = document.querySelector('[data-membership-anchor-wrap]')
    this.anchorItems = document.querySelectorAll('[data-membership-anchor-item]')
    this.anchorDeco = document.querySelector('[data-membership-anchor-deco]')

    // 无活动状态
    this.noActivityDOM = document.querySelector('[data-membership-no-activity]')

    // 左右箭头
    this.leftArrowBtn = document.querySelector('.membership-anchor-left-arrow')
    this.rightArrowBtn = document.querySelector('.membership-anchor-right-arrow')

    this.activeIndex = 0    // 当前 active index
    this.scrolling = false  // 滚动状态锁

    if (this.anchorItems.length > 0) {
      this.init()

      // 监听容器大小变化
      this.resizeObserver = new ResizeObserver(debounce(() => {
        this.resize()
      }, 100))

      if (this.anchorSection) {
        this.resizeObserver.observe(this.anchorSection)
      }

      // 监听页面滚动
      this.scrollHandler = throttle(() => this.watchScroll(), 100);
      window.addEventListener('scroll', this.scrollHandler)

      // 页面重载前保存状态
      this.beforeUnloadHandler = () => {
        sessionStorage.setItem('jk_membership_anchor_index', this.activeIndex)
        sessionStorage.setItem('jk_membership_scroll_y', window.scrollY)
      }
      window.addEventListener('beforeunload', this.beforeUnloadHandler)
    }

    // 处理无活动逻辑
    if (this.noActivityDOM && this.anchorSection) {
      this.anchorSection.parentElement.style.position = 'relative'
      this.anchorWrap.innerHTML = ''
      this.leftArrowBtn?.classList.add('hidden')
      this.rightArrowBtn?.classList.add('hidden')

      if (this.isMobile()) {
        this.anchorSection.style.height = '0px'
      }
    }
  }

  init() {
    this.initArrowDisplay()

    this.anchorItems.forEach((item, index) => {
      item.onclick = () => {
        if (this.scrolling) return

        // 点击时立即同步更新索引
        this.activeIndex = index
        
        // 更新箭头状态
        this.updateArrowDisabled(index)

        // 【关键】执行纵向滚动，内部会调用 updateItem(item, true)
        this.scrollToAnchorDOM(item)

        // 处理横向平滑滚动（包裹容器）
        this.handleSmoothScroll(item)
      }
    })

    this.anchorWrap.classList.add('transition-all', 'duration-300')

    this.leftArrowBtn.onclick = () => this.handleArrow('left')
    this.rightArrowBtn.onclick = () => this.handleArrow('right')

    this.handleRefresh()
  }

  // 处理页面刷新后的位置恢复
  handleRefresh() {
    const _activeIndex = sessionStorage.getItem('jk_membership_anchor_index') || 0
    const _scroll_y = sessionStorage.getItem('jk_membership_scroll_y') || 0

    const targetIndex = parseInt(_activeIndex)
    if (this.anchorItems[targetIndex]) {
      this.activeIndex = targetIndex
      // 初始回显不需要动画
      this.updateItem(this.anchorItems[targetIndex], true)
    }

    window.scrollTo(0, _scroll_y)

    sessionStorage.removeItem('jk_membership_anchor_index')
    sessionStorage.removeItem('jk_membership_scroll_y')
  }

  initArrowDisplay() {
    if (this.anchorWrap.scrollWidth > this.anchorWrap.offsetWidth && !this.isMobile()) {
      this.leftArrowBtn.classList.remove('hidden')
      this.rightArrowBtn.classList.remove('hidden')
      this.anchorWrap.classList.remove('lg:flex-center')
    } else {
      this.leftArrowBtn.classList.add('hidden')
      this.rightArrowBtn.classList.add('hidden')
      this.anchorWrap.classList.add('lg:flex-center')
    }
  }

  /**
   * 更新 Deco 和 Item 状态
   * @param {HTMLElement} item 当前目标元素
   * @param {Boolean} withoutAnimation 是否禁用动画（点击时为 true）
   */
  updateItem(item, withoutAnimation) {
    if (!item || !this.anchorDeco) return;

    if (withoutAnimation) {
      // 1. 彻底移除 CSS 类
      this.anchorDeco.classList.remove('transition-all', 'duration-300');
      // 2. 强制设置 transition 为 none，防止被 CSS 文件中的样式干扰
      this.anchorDeco.style.transition = 'none';
    } else {
      // 恢复平滑过渡
      this.anchorDeco.classList.add('transition-all', 'duration-300');
      this.anchorDeco.style.transition = '';
    }

    // 更新 active 类
    this.anchorItems.forEach(t => t.classList.remove('active'));
    item.classList.add('active');
    
    // 设置位置
    this.anchorDeco.style.width = item.offsetWidth + 'px';
    this.anchorDeco.style.left = item.offsetLeft + 'px';
    this.anchorDeco.style.opacity = '1';

    if (withoutAnimation) {
      // 3. 核心：强制浏览器重绘，确保上述样式立即生效而不产生过渡
      this.anchorDeco.offsetHeight; 
    }
  }

  handleArrow(direction) {
    if (this.scrolling) return

    const updateIndex =
      direction === 'left'
        ? Math.max(this.activeIndex - 1, 0)
        : Math.min(this.activeIndex + 1, this.anchorItems.length - 1)

    this.activeIndex = updateIndex
    this.updateArrowDisabled(updateIndex)

    const item = this.anchorItems[updateIndex]
    this.scrollToAnchorDOM(item)
    this.handleSmoothScroll(item)
  }

  updateArrowDisabled(index) {
    this.leftArrowBtn.toggleAttribute('disabled', index === 0)
    this.rightArrowBtn.toggleAttribute('disabled', index === this.anchorItems.length - 1)
  }

  resize() {
    this.initArrowDisplay()
    const currentItem = this.anchorItems[this.activeIndex]
    if (currentItem) {
      // Resize 时通常不需要动画，直接对齐
      this.updateItem(currentItem, true)
    }
  }

  scrollToAnchorDOM(item) {
    // 点击时触发，不使用动画，直接定位 deco
    this.updateItem(item, true)

    const id = item.dataset.id
    const targetEl = document.getElementById(id)
    if (id && targetEl) {
      const offsetTop = targetEl.offsetTop
      const sectionHeight = this.anchorSection.offsetHeight
      
      this.interruptCurrentScroll()
      this.startNewScroll(offsetTop, sectionHeight)
    }
  }

  interruptCurrentScroll() {
    if (this.scrollendHandler) {
      document.removeEventListener('scrollend', this.scrollendHandler)
    }
    this.scrolling = false
  }

  startNewScroll(offsetTop, sectionHeight) {
    this.scrolling = true

    window.scrollTo({
      top: offsetTop - sectionHeight,
      behavior: 'smooth',
    })

    // 定义滚动结束的处理逻辑
    this.scrollendHandler = () => {
      this.scrolling = false
      document.removeEventListener('scrollend', this.scrollendHandler)
    }

    document.addEventListener('scrollend', this.scrollendHandler)
  }

  watchScroll() {
    // 如果正在执行点击产生的平滑滚动，则不执行滚动监听逻辑，避免 Deco 抖动
    if (this.scrolling) return

    const sectionHeight = this.anchorSection.offsetHeight 
    let targetIndex = 0

    for (let i = this.anchorItems.length - 1; i >= 0; i--) {
      const el = document.getElementById(this.anchorItems[i]?.dataset?.id)
      if (el && window.scrollY >= el.offsetTop - sectionHeight - 10) {
        targetIndex = i
        break
      }
    }

    if (this.activeIndex !== targetIndex) {
      this.activeIndex = targetIndex
      this.updateArrowDisabled(this.activeIndex)
      // 随页面滚动触发的更新，建议保留动画，体验更佳
      this.updateItem(this.anchorItems[this.activeIndex], false)
      this.handleSmoothScroll(this.anchorItems[this.activeIndex])
    }
  }

  isMobile() {
    return window.innerWidth < 1024
  }

  // 顶部导航条内部的横向滚动平滑处理
  handleSmoothScroll(item) {
    if (!item || !this.anchorWrap) return;
    
    const containerWidth = this.anchorWrap.offsetWidth;
    const itemOffsetLeft = item.offsetLeft;
    const itemWidth = item.offsetWidth;

    // 计算让 Item 居中的 scrollLeft 值
    const targetScrollLeft = itemOffsetLeft - (containerWidth / 2) + (itemWidth / 2);

    this.anchorWrap.scrollTo({
      left: targetScrollLeft,
      behavior: 'smooth'
    });
  }

  destroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect()
    
    document.removeEventListener('scrollend', this.scrollendHandler)
    window.removeEventListener('scroll', this.scrollHandler)
    window.removeEventListener('beforeunload', this.beforeUnloadHandler)
  }
}